import React from 'react';

//import { useCmnz } from './_csCmn';

import * as ht from './_ht';
import * as cv from './_cv';

import { useClrz } from './_csClr';
import { useDsnz } from './_csDsn';
import { useSclz } from './_csScl';

let _cashz = {} as ht.dz;

export const clr = () => {
  _cashz = {};
};

export const a = (
  pCls: ht.s,
) => {

  const _gClrz = useClrz();
  const _gDsnz = useDsnz();
  const _gSclz = useSclz();

  if (_cashz[pCls]) return _cashz[pCls];

  const _cnv = (pCls: ht.s): ht.dz => {
    const [_clsType, _clsVle] = pCls.split('/');
    switch (_clsType) {
      case 'bc': // border color
        return {
          borderColor: _gClrz.c(_clsVle),
//          'border-color': _gClrz.c(_clsVle),
        };
      case 'bd': // border dashed
        return {
          borderStyle: 'dashed',
        };
      case 'br': // border radius
        return {
          borderRadius: _gSclz.s(Number(_clsVle)),
        };
      case 'brb': // border radius bottom
        return {
          borderBottomLeftRadius: _gSclz.s(Number(_clsVle)),
          borderBottomRightRadius: _gSclz.s(Number(_clsVle)),
        };
      case 'brl': // border radius left
        return {
          borderTopLeftRadius: _gSclz.s(Number(_clsVle)),
          borderBottomLeftRadius: _gSclz.s(Number(_clsVle)),
        };
      case 'brr': // border radius right
        return {
          borderTopRightRadius: _gSclz.s(Number(_clsVle)),
          borderBottomRightRadius: _gSclz.s(Number(_clsVle)),
        };
      case 'brt': // border radius top
        return {
          borderTopLeftRadius: _gSclz.s(Number(_clsVle)),
          borderTopRightRadius: _gSclz.s(Number(_clsVle)),
        };
      case 'bs': // border style
        return {
          borderStyle: 
            _clsVle == 'sd' ? 
              'solid'
            : _clsVle == 'ds' ? 
              'dotted'
            :
              'solid',
/*
          'border-style': 
            _clsVle == 'sd' ? 
              'solid'
            : _clsVle == 'ds' ? 
              'dashed'
            : _clsVle == 'dt' ? 
              'dotted'
            :
              'solid',
*/
        };
      case 'bw': // border width
        return {
          borderTopWidth: Number(_clsVle),
          borderBottomWidth: Number(_clsVle),
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: Number(_clsVle),
//          'border-width': Number(_clsVle),
        };
      case 'bwv': // border width vertical
        return {
          borderTopWidth: Number(_clsVle),
          borderBottomWidth: Number(_clsVle),
        };
      case 'bwh': // border width horizontal
        return {
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: Number(_clsVle),
        };
      case 'bwb': // border width bottom
        return {
          borderBottomWidth: Number(_clsVle),
          borderTopWidth: 0,
        };
      case 'bwt': // border width top
        return {
          borderBottomWidth: 0,
          borderTopWidth: Number(_clsVle),
        };
      case 'bwl': // border width left
        return {
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: 0,
        };
      case 'bwr': // border width right
        return {
          borderLeftWidth: 0,
          borderRightWidth: Number(_clsVle),
        };
/*
      case 'bgc': // background color
        return {
          backgroundColor: _gClrz.c(_clsVle),
        };
*/
      case 'db': // dimension bottom
        return {
          bottom:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'n' ? 
                null
              : _clsVle == 'dvc' ? 
                _gDsnz.h('dvc')
              : _clsVle == 'hdr' ? 
                _gDsnz.h('hdr')
              : _clsVle == 'bdy' ? 
                _gDsnz.h('bdy')
              : _clsVle == 'ftr' ? 
                _gDsnz.h('ftr')
              : _clsVle == 'mdl' ? 
                (_gDsnz.h('dvc') - _gDsnz.h('mdl')) / 2
              : _gSclz.s(Number(_clsVle)),
        };

      case 'dh': // dimension height
        if ( _clsVle != 'ecp') { // escape
          return {
            height:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'dvc' ? 
                _gDsnz.h('dvc')
              : _clsVle == 'hdr' ? 
                _gDsnz.h('hdr')
              : _clsVle == 'bdy' ? 
                _gDsnz.h('bdy')
              : _clsVle == 'n' ? 
                null
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dhn': // dimension min height
        if ( _clsVle != 'ecp') { // escape
          return {
            minHeight:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dhx': // dimension max height
        if ( _clsVle != 'ecp') { // escape
          return {
            maxHeight:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dhp': // dimension height
        return {
          height: Number(_clsVle),
        };

      case 'dl': // dimension left
        return {
          left:
            _clsVle == 'mdl' ? // 廃止予定
              (_gDsnz.w('dvc') - _gDsnz.w('mdl')) / 2
            : _clsVle == 'f' ? 
              '100%' 
            : _clsVle == 'h' ? 
              '50%' 
            : _clsVle == 'q' ? 
              '25%' 
            : _clsVle == 'n' ? 
              null
            : _gSclz.s(Number(_clsVle)),
        };

      case 'dlp': // dimension left px
        return {
          left: _clsVle,
        };

      case 'dr': // dimension right
        return {
          right:
            _clsVle == 'mdl' ? // 廃止予定
              (_gDsnz.w('dvc') - _gDsnz.w('mdl')) / 2
            : _clsVle == 'f' ? 
              '100%' 
            : _clsVle == 'h' ? 
              '50%' 
            : _clsVle == 'q' ? 
              '25%' 
            : _clsVle == 'n' ? 
              null
            : _gSclz.s(Number(_clsVle)),
        };

      case 'dp': // dimension position
        return {
          position: 
            _clsVle == 'a' ? 
              'absolute'
            : _clsVle,
        };

      case 'dt': // dimension top
        return {
          top:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'n' ? 
                null
              : _clsVle == 'dvc' ? 
                _gDsnz.h('dvc')
              : _clsVle == 'hdr' ? 
                _gDsnz.h('hdr')
              : _clsVle == 'bdy' ? 
                _gDsnz.h('bdy')
              : _clsVle == 'ftr' ? 
                _gDsnz.h('ftr')
              : _clsVle == 'mdl' ? 
                (_gDsnz.h('dvc') - _gDsnz.h('mdl')) / 2
              : _gSclz.s(Number(_clsVle)),
        };

      case 'dtp': // dimension top px
        return {
          top: _clsVle,
        };

      case 'dw': // dimension width
        if ( _clsVle != 'ecp') { // escape
          return {
            width: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'btn' ? // button
                _gSclz.s(10)
              : _clsVle == 'date' ? // date
                _gSclz.s(13)
              : _clsVle == 'dvc' ? 
                _gDsnz.w('dvc')
              : _clsVle == 'mdl' ? 
                _gDsnz.w('mdl')
              : _clsVle == 'icn' ? // icon
                _gSclz.s(5)
              : _clsVle == 'n' ? 
                null
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dwn': // dimension min width
        if ( _clsVle != 'ecp') { // escape
          return {
            minWidth: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dwp': // dimension height
        return {
          width: Number(_clsVle),
        };

      case 'dwx': // dimension max width
        if ( _clsVle != 'ecp') { // escape
          return {
            maxWidth: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _clsVle == 's15' ? 
                80 * 15 
              : _gSclz.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dz': // dimension zIndex
        return {
          zIndex: 
            _clsVle == 'bdy' ? 
              cv.zIdxBdy
            : _clsVle == 'mdl' ? 
              cv.zIdxMdl
            : _clsVle == 'mdl+1' ? 
              cv.zIdxMdl+1
            : _clsVle == 'mdl+2' ? 
              cv.zIdxMdl+2
            : _clsVle,
        };

      case 'f': // flex
        return {
          flex: 
            _clsVle == 'n' ? 
              null
            : _clsVle,
        };

      case 'fd': // flex direction
        switch ( _clsVle ) {
          case 'cac':
            return {
              flexDirection: 'column', 
              justifyContent: 'space-evenly', 
              alignItems: 'center', 
            }
          case 'ccc':
            return {
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'center', 
            }
          case 'ccs':
            return {
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'flex-start', 
            }
          case 'crac':
            return {
              flexDirection: 'column-reverse', 
              justifyContent: 'space-evenly', 
              alignItems: 'center', 
            }
          case 'csc':
            return {
              flexDirection: 'column', 
              justifyContent: 'flex-start', 
              alignItems: 'center', 
            }
          case 'css':
            return {
              flexDirection: 'column', 
              justifyContent: 'flex-start', 
              alignItems: 'flex-start', 
            }
          case 'rac':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-evenly', 
              alignItems: 'center', 
            }
          case 'ras':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-evenly', 
              alignItems: 'flex-start', 
            }
          case 'rbc':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
            }
          case 'rbs':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              alignItems: 'flex-start', 
            }
          case 'rcc':
            return {
              flexDirection: 'row', 
              justifyContent: 'center', 
              alignItems: 'center', 
            }
          case 'rec':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-end', 
              alignItems: 'center', 
            }
          case 'rsc':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-start', 
              alignItems: 'center', 
            }
          case 'rss':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-start', 
              alignItems: 'flex-start', 
            }
          default:
            return {
              flexDirection:  
                _clsVle == 'c' ?
                  'column'
                : _clsVle == 'n' ?
                  'column-reverse'
                : _clsVle == 'r' ?
                  'row'
                : _clsVle == 'w' ?
                  'row-reverse'
                : _clsVle,
            }
        }

      case 'fj': // flex justify content
        return {
          justifyContent: 
            _clsVle == 'a' ? 
              'space-evenly'
            : _clsVle == 'b' ? 
              'space-between'
            : _clsVle == 'c' ? 
              'center'
            : _clsVle == 'e' ? 
              'flex-end'
            : _clsVle == 's' ? 
              'flex-start'
            : _clsVle,
        };

      case 'fa': // flex alignItems
        return {
          alignItems:  
            _clsVle == 'a' ? 
              'space-evenly'
            : _clsVle == 'b' ? 
              'space-between'
            : _clsVle == 'c' ? 
              'center'
            : _clsVle == 'e' ? 
              'flex-end'
            : _clsVle == 's' ? 
              'flex-start'
            : _clsVle,
        };

      case 'fw': // flex wrap
        return {
          flexWrap: 'wrap',
        };

      case 'ioc': // input outline color
        return {
          outlineColor:  _gClrz.c(_clsVle),
        };

      case 'iow': // input outline width
        return {
          outlineWidth:  Number(_clsVle),
        };

      case 'icc': // icon color
        return {
          color:  _gClrz.c(_clsVle),
        };

      case 'icn': // icon name
        return {
          name:  _clsVle,
        };

      case 'ics': // icon size
        return {
          size:  _gSclz.s(Number(_clsVle)),
        };

      case 'm': // margin all
        return {
          marginTop: _gSclz.s(Number(_clsVle)),
          marginBottom: _gSclz.s(Number(_clsVle)),
          marginLeft: _gSclz.s(Number(_clsVle)),
          marginRight: _gSclz.s(Number(_clsVle)),
        };
      case 'mv': // margin vertical
        return (
          _clsVle == 'a' ?
          {
            marginTop: 'auto',
            marginBottom: 'auto',
          }
          :
          {
            marginTop: _gSclz.s(Number(_clsVle)),
            marginBottom: _gSclz.s(Number(_clsVle)),
          }
        );
      case 'mh': // margin horizontal
        return (
          _clsVle == 'a' ?
          {
            marginLeft: 'auto',
            marginRight: 'auto',
          }
          :
          {
            marginLeft: _gSclz.s(Number(_clsVle)),
            marginRight: _gSclz.s(Number(_clsVle)),
          }
        );
      case 'mt': // margin top
        return {
          marginTop: _gSclz.s(Number(_clsVle)),
        };
      case 'mb': // margin bottom
        return {
          marginBottom: _gSclz.s(Number(_clsVle)),
        };
      case 'ml': // margin left
        return {
          marginLeft: _gSclz.s(Number(_clsVle)),
        };
      case 'mr': // margin right
        return {
          marginRight: _gSclz.s(Number(_clsVle)),
        };

      case 'p': // padding all
        return {
          paddingTop: _gSclz.s(Number(_clsVle)),
          paddingBottom: _gSclz.s(Number(_clsVle)),
          paddingLeft: _gSclz.s(Number(_clsVle)),
          paddingRight: _gSclz.s(Number(_clsVle)),
        };
      case 'pv': // padding vertical
        return (
        {
          paddingTop: _gSclz.s(Number(_clsVle)),
          paddingBottom: _gSclz.s(Number(_clsVle)),
        }
        );
      case 'ph': // padding horizontal
        return (
        {
          paddingLeft: _gSclz.s(Number(_clsVle)),
          paddingRight: _gSclz.s(Number(_clsVle)),
        }
        )
      case 'pt': // padding top
        return {
          paddingTop: _gSclz.s(Number(_clsVle)),
        };
      case 'pb': // padding bottom
        return {
          paddingBottom: _gSclz.s(Number(_clsVle)),
        };
      case 'pl': // padding left
        return {
          paddingLeft: _gSclz.s(Number(_clsVle)),
        };
      case 'pr': // padding right
        return {
          paddingRight: _gSclz.s(Number(_clsVle)),
        };
      case 'prx': // padding right
        return {
          paddingRight: Number(_clsVle),
        };

      case 'sc': // background color
        return {
          backgroundColor: _gClrz.c(_clsVle),
        };

      case 'ta': // text align
        return {
          textAlign: 
            _clsVle == 'c' ? 
              'center'
            : _clsVle == 'l' ? 
              'left'
            : _clsVle == 'r' ? 
              'right'
            : _clsVle,
        };

      case 'tb': // text font style bold
        return {
          fontWeight: 
            _clsVle == 'n' ? 
              'normal'
            : 'bold',
        };

      case 'tc': // text font color
        return {
          color: _gClrz.c(_clsVle),
        };

      case 'tf': // text font family
        return {
          fontFamily: _clsVle,
        };

      case 'th': // text font style italic
        return {
          lineHeight: _gSclz.s(Number(_clsVle)),
        };

      case 'ti': // text font style italic
        return {
          fontStyle: 'italic',
        };

      case 'tm': // text multiline
        return {
          multiline: 
            _clsVle == 'n' ? 
            false
          : true,
        };

      case 'tn': // text number of lines
        return {
          numberOfLines: Number(_clsVle),
          ellipsizeMode: 'tail',
        };

/*
      case 'ts': // text font size
        return {
          fontSize:
            _clsVle == 'm' ?
              _gSclz.s(2.5) //2.0
            : _clsVle == 's' ?
              _gSclz.s(2.125) // 1.7
            : _clsVle == 'xs' ?
              _gSclz.s(1.75) // 1.4
            : _clsVle == 'xxs' ?
              _gSclz.s(1.375) // 1.1
            : _clsVle == 'l' ?
              _gSclz.s(2.875) // 2.3
            : _clsVle == 'xl' ?
              _gSclz.s(3.25) // 2.6
            : _clsVle == 'xxl' ?
              _gSclz.s(3.625) // 2.9
            : _gSclz.s(Number(_clsVle)),
        };
*/
      case 'ts': // text font size
        return {
          fontSize:
            _clsVle == 'm' ?
              _gSclz.s(2.0) //2.0
            : _clsVle == 's' ?
              _gSclz.s(1.7) // 1.7
            : _clsVle == 'xs' ?
              _gSclz.s(1.4) // 1.4
            : _clsVle == 'xxs' ?
              _gSclz.s(1.1) // 1.1
            : _clsVle == 'l' ?
              _gSclz.s(2.3) // 2.3
            : _clsVle == 'xl' ?
              _gSclz.s(2.6) // 2.6
            : _clsVle == 'xxl' ?
              _gSclz.s(2.9) // 2.9
            : _gSclz.s(Number(_clsVle)),
        };

      case 'tu': // text font style underline
        return {
          textDecoration: 'underline',
        };

      default:
        //console.log('csStl 167: incorrect class Name: ' + pCls)
        return {
        }
    }
  };

  const _ls1 = pCls.split(' ');
  const _ls2 = _ls1.map( (_s: ht.s) => _cnv(_s) );
  let _stlz = {};
  _ls2.map( _dz => {
    _stlz = {
      ..._stlz,
      ..._dz,
    }
  });

  _cashz[pCls] = _stlz;

  return _stlz;

};
